/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const Warning: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 28 28" size={size} color={color} {...props}>
      <path
        d="M13.059 3.619c.419-.825 1.463-.825 1.882 0l9.911 19.521c.42.826-.104 1.86-.941 1.86H4.089c-.837 0-1.36-1.034-.941-1.86L13.059 3.62zm-.171 9.178l.339 4.936h1.548l.339-4.936.08-2.145h-2.387l.08 2.145zm-.323 7.371c0 .42.137.772.412 1.057.274.285.615.427 1.024.427.408 0 .75-.142 1.024-.427.274-.285.411-.637.411-1.057 0-.43-.137-.787-.411-1.072A1.363 1.363 0 0014 18.668c-.409 0-.75.143-1.024.428-.275.285-.412.642-.412 1.072z"
        fillRule="evenodd"
      />
    </Icon>
  );
};

export default Warning;

Warning.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
